import React from 'react'

const Navbar = () => {
  return (
    <div className="row">
      <header className="header-master">
        <div className="logo">
          <img src="/logo.png" alt="University Logo" />
        </div>
        <nav className="pull-right">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
          </ul>
        </nav>
      </header>
      <div className="main-nav">
        <ul>
          <li />
        </ul>
      </div>
    </div>
  )
}

export default Navbar
